// Generated by CoffeeScript 1.12.7
(function () {
  var SidebarType;

  SidebarType = require("../../Stores/SidebarViewStore/SidebarViewStore").SidebarType;

  /*
    Provides a Sidebar type navigation menu for the project editor context.
   */

  module.exports = function (createUi, invoke, sidebarViewStore) {
    var navList, ui;
    navList = invoke(require("./../NavigationList/NavigationList"), null, {
      screenSide: "left",
      isClosed: function () {
        return ui.isClosed();
      },
    });
    return (ui = createUi(require("./SidebarMenu.html"), {
      navList: navList,
      isClosed: function () {
        return !sidebarViewStore.sidebarIsOpen(SidebarType.NavigationSidebarList);
      },
      toggleClosed: function () {
        var newIsClosed;
        newIsClosed = !ui.isClosed();
        if (newIsClosed) {
          return sidebarViewStore.closeSidebar();
        } else {
          return sidebarViewStore.openSidebar(SidebarType.NavigationSidebarList);
        }
      },
    }));
  };
}.call(this));
